module.exports = __webpack_public_path__ + "static/media/flip.915c2113.gif";